import { Injectable } from '@angular/core';
import { isDownloadable, mapTypeToIcon } from 'src/app/helpers';
import { IAdapter } from 'src/app/models/adapter';
import {
  ItemRevision,
  ItemRevisionDataset,
  ItemRevisionProject,
  PartDesignItemStructure,
} from 'src/app/models/domain';
import { IPartDesignItemStructureDTO } from 'src/app/models/legorestapi';
import { ItemRevisionReferenceAdapter } from './item-revision-reference-adapter';
import { ItemStructureAdapter } from './item-structure-adapter';

@Injectable({
  providedIn: 'root',
})
export class PartDesignItemStructureAdapter implements IAdapter<
  PartDesignItemStructure,
  IPartDesignItemStructureDTO
> {
  public constructor(
    private readonly itemStructureAdapter: ItemStructureAdapter,
    private readonly itemRevisionReferenceAdapter: ItemRevisionReferenceAdapter
  ) {}

  public adaptToDomain(itemDto: IPartDesignItemStructureDTO): PartDesignItemStructure {
    return new PartDesignItemStructure(
      itemDto.itemId,
      itemDto.itemName,
      itemDto.itemType,
      (itemDto.revisions ?? [])
        .slice()
        .reverse()
        .map(
          (itemRevision) =>
            new ItemRevision(
              (itemRevision.datasets ?? []).map(
                (itemRevisionDataset) =>
                  new ItemRevisionDataset(
                    itemRevisionDataset.name,
                    itemRevisionDataset.relation,
                    mapTypeToIcon(itemRevisionDataset.type),
                    isDownloadable(itemRevisionDataset.type) ? itemRevisionDataset.link : undefined,
                    itemRevisionDataset.original_file_name
                  )
              ),
              (itemRevision.projects ?? []).map(
                (project) => new ItemRevisionProject(project.id, project.name)
              ),
              (itemRevision.references ?? []).map((reference) =>
                this.itemRevisionReferenceAdapter.adaptToDomain(reference)
              ),
              itemRevision.releaseStatus,
              itemRevision.revId,
              itemRevision.chgShortNote ?? '',
              itemRevision.revDesc ?? '',
              itemRevision.chgNote ?? '',
              itemRevision.chgNumber ?? '',
              itemRevision.weight ?? ''
            )
        ),
      itemDto.tsItem ? this.itemStructureAdapter.adaptToDomain(itemDto.tsItem) : undefined,
      itemDto.csItem ? this.itemStructureAdapter.adaptToDomain(itemDto.csItem) : undefined,
      itemDto.apItem ? this.itemStructureAdapter.adaptToDomain(itemDto.apItem) : undefined
    );
  }
}
